// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".metadata-category[data-v-1eb13526]{cursor:pointer;border-bottom:1px solid #fff}.metadata-category.active[data-v-1eb13526],.metadata-category[data-v-1eb13526]:hover{background-color:#eff2f7}.metadata-category .chevron-right[data-v-1eb13526]{float:right;display:none}.metadata-category.active .chevron-right[data-v-1eb13526]{display:block;position:relative;top:1px}", ""]);
// Exports
module.exports = exports;
